export const ATTACHMENTS_BUCKET =
  import.meta.env.VITE_ATTACHMENTS_BUCKET || "attachments";

export const PROPOSALS_BUCKET =
  import.meta.env.VITE_PROPOSALS_BUCKET || "propostas-pdf";
